import type { Socket } from "socket.io-client";

import { create } from "zustand";

import { createSocketConnection } from "@/socket";

type SocketState = {
  socket: Socket | null;
  initializeSocket: (token?: string) => void;
  reconnectSocket: (token: string) => void;
  disconnectSocket: () => void;
};

export const useSocketStore = create<SocketState>((set, get) => ({
  socket: null,

  initializeSocket: () => {
    if (!get().socket) {
      const newSocket = createSocketConnection();
      set({ socket: newSocket });
    }
  },

  reconnectSocket: (token: string) => {
    const { socket } = get();
    if (socket) {
      socket.disconnect();
      socket.close();
    }
    const newSocket = createSocketConnection(token);
    set({ socket: newSocket });
  },

  disconnectSocket: () => {
    const { socket } = get();
    if (socket) {
      socket.disconnect();
      socket.close();
      set({ socket: null });
    }
  },
}));
